import React from 'react';

import {
  AppFullScreenContainer,
  FilterMap,
} from 'src/components';
import { locals } from 'src/constants/locals';
import {
  useSetDocumentTitle,
  useTranslations,
  useDisablePinchZoomEffect,
  useBuildType, useTypeDisplayedSpinner,
} from 'src/hooks';
import { FilterDesktop } from 'src/components/FilterProperty/components';
import { TypesOfSpinner } from 'src/typings/types-of-spinner';

export const MainPage: React.FC = () => {
  const { getTranslations } = useTranslations();
  const { isMarketplace } = useBuildType();
  useDisablePinchZoomEffect();
  useSetDocumentTitle(!isMarketplace ? getTranslations(locals.appTranslations.appTitleMainPage) : 'MARKETPLACE');
  const { getSelectedViewId } = useTypeDisplayedSpinner();
  const isFloors = TypesOfSpinner.viewFloors === getSelectedViewId;

  return (
    <>
      <AppFullScreenContainer showSwitcher={isFloors}>
        <>
          <FilterDesktop />
          <FilterMap />
        </>
      </AppFullScreenContainer>
    </>
  );
};
